import * as C from '../constants';

export const getSelectedPlanKey = (state: PlansState) => state.selected;

export const getPlanIsFetching = (state: PlansState) => state.isFetching;

export const getFixedCost = (state: PlansState) => state.fixedCost;

const getVariableCostMonthly = (state: PlansState) => state.variableCostMonthly;

const getVariableCostYearly = (state: PlansState) => state.variableCostYearly;

export const getMonthlyCostPerMonth = (state: PlansState) =>
  getVariableCostMonthly(state);

export const getYearlyCostPerYear = (state: PlansState) =>
  getVariableCostYearly(state);

export const getYearlyCostPerMonth = (state: PlansState) =>
  getVariableCostYearly(state) / 12;

// Returns the cost savings in %.
export const getYearlyCostSavings = (state: PlansState) =>
  1 - getYearlyCostPerMonth(state) / getMonthlyCostPerMonth(state);

export const getTrialCost = (state: PlansState) => state.trialCost;

// const getTrialCostPerMonth = (state: PlansState) => getTrialCost(state) / getTrialDuration(state) * 30;

// Assume backend always returns units in days.
export const getTrialDuration = (state: PlansState) => state.trialDuration;

export const getTotalCost = (state: PlansState) => {
  switch (state.selected) {
    case C.PLANS.MONTHLY:
      return getFixedCost(state) + getMonthlyCostPerMonth(state);
    case C.PLANS.YEARLY:
      return getFixedCost(state) + getYearlyCostPerYear(state);
    case C.PLANS.TRIAL:
      return getFixedCost(state) + getTrialCost(state);
  }
  return 0;
};

export const getRecurringCostPayableToday = (state: PlansState) => {
  switch (state.selected) {
    case C.PLANS.MONTHLY:
      return getMonthlyCostPerMonth(state);
    case C.PLANS.YEARLY:
      return getYearlyCostPerYear(state);
    case C.PLANS.TRIAL:
      return 0;
  }
  return 0;
};

export const getNonRecurringCostPayableToday = (state: PlansState) => {
  switch (state.selected) {
    case C.PLANS.MONTHLY:
      return getFixedCost(state);
    case C.PLANS.YEARLY:
      return getFixedCost(state);
    case C.PLANS.TRIAL:
      return getFixedCost(state) + getTrialCost(state);
  }
  return 0;
};

const initialState: PlansState = {
  isFetching: false,
  selected: C.PLANS.YEARLY,
  fixedCost: 0,
  variableCostYearly: 0,
  variableCostMonthly: 0,
  trialCost: 0,
  trialDuration: 0,
  priceDetials: {
    data_items: {},
    shop_item_categories: {},
  },
};

function handlePlanSelect(
  state: PlansState,
  action: PlanSelectAction
): PlansState {
  return {
    ...state,
    selected: action.payload.plan,
  };
}

function handlePlanFetch(state: PlansState, action: Action): PlansState {
  return {
    ...state,
    isFetching: true,
  };
}

function handlePlanFetchFailed(state: PlansState, action: Action): PlansState {
  return {
    ...state,
    isFetching: false,
  };
}

function handlePlanReceivedPricing(
  state: PlansState,
  action: PlanReceivedPricing
): PlansState {
  return {
    ...state,
    isFetching: false,
    fixedCost: action.payload.plans['one-off'],
    variableCostMonthly: action.payload.plans.recurring.monthly,
    variableCostYearly: action.payload.plans.recurring.yearly,
    trialCost: action.payload.plans.trial.cost,
    trialDuration: action.payload.plans.trial.duration,
    priceDetials: action.payload.plans.details,
  };
}

export default function plans(
  state: PlansState = initialState,
  action: Action
): PlansState {
  switch (action.type) {
    case C.ACTION_TYPES.PLAN_SELECT:
      return handlePlanSelect(state, action as PlanSelectAction);
    case C.ACTION_TYPES.PLAN_RECEIVED_PRICING:
      return handlePlanReceivedPricing(state, action as PlanReceivedPricing);
    case C.ACTION_TYPES.PLAN_FETCH_PLAN_PRICING:
      return handlePlanFetch(state, action);
    case C.ACTION_TYPES.PLAN_FETCH_PLAN_PRICING_ERROR:
      return handlePlanFetchFailed(state, action);
  }
  return state;
}



// WEBPACK FOOTER //
// ./app/reducers/plans.ts